module.exports = __webpack_public_path__ + "895d8e1366f87476a4d0cca3122feb50.jpg";